$(document).ready(function () {

    const renderStars = (element) => {
        const rating = element.attr('data-rating');
        let c = 0;
        element.find('.rating-stars__star').removeClass('filled').each(function() {
            if (c < Math.floor(rating)) {
                $(this).addClass('filled');
                c++;
            }
        })
    }

    const moveElement = (element, target, screenSize, append = true, after = false) => {
        if (screen.width < screenSize) {
            if (after) {
                for (let i = 0; i < $(element).length; i++) {
                    $(target).eq(i).after($(element).eq($(target).length === 1 ? 0 : i))
                }
            } else {
                if (append) {
                    for (let i = 0; i < $(element).length; i++) {
                        $(element).eq(i).appendTo($(target).eq($(target).length === 1 ? 0 : i))
                    }
                } else {
                    for (let i = 0; i < $(element).length; i++) {
                        $(element).eq(i).prependTo($(target).eq($(target).length === 1 ? 0 : i))
                    }
                }
            }
        }
    }

    moveElement('.product-card-main__product-number-box', '.product-card-main__inner', 991, false);
    moveElement('.modal__tags-wrapper', '.modal__rating-left', 991, false, true);
    moveElement('.modal .file-upload', '.modal__fields', 991, false, true);
    moveElement('.category-sidebar__categories', '.category-top__container', 991, false, false);

    function loadScript(url, callback) {
        var script = document.createElement("script");
        script.src = url;
        script.async = true;
        script.onload = callback;
        document.head.appendChild(script);
    }



    setTimeout(function () {
        const header = $('.header');
        const headerHeight = header.height();
        const mobileCategoriesMenu = $('.category-sidebar__categories');
        let mobileCategoriesMenuY, mobileCategoriesMenuHeight, headerFixedHeight
        if (mobileCategoriesMenu.length > 0) {
            mobileCategoriesMenuY = mobileCategoriesMenu.offset().top;
            mobileCategoriesMenuHeight = mobileCategoriesMenu.innerHeight();
            header.addClass('fixed');
            headerFixedHeight = header.height();
            header.removeClass('fixed');
        }

        let shareIsVisible = false;
        const checkVisible = () => {
            $('.ya-share2').each(function () {
                if(!shareIsVisible && $(this).visible())  {
                    shareIsVisible = true;
                    loadScript('https://yastatic.net/share2/share.js', ()=>{})
                }
            })
        }

        const checkMobileCategories = () => {
            if ($(window).scrollTop() > mobileCategoriesMenuY) {
                mobileCategoriesMenu.addClass('fixed');
                mobileCategoriesMenu.css('top', headerFixedHeight);
                mobileCategoriesMenu.parent().css('padding-top', mobileCategoriesMenuHeight);
            } else {
                mobileCategoriesMenu.removeClass('fixed').removeAttr('style');
                mobileCategoriesMenu.parent().removeAttr('style');
            }
        }

        checkVisible();
        if (screen.width < 992 && mobileCategoriesMenu.length > 0) {
            checkMobileCategories();
        }

        window.addEventListener('scroll', function () {
            checkVisible();
            if (screen.width < 992) {
                checkMobileCategories();
            }
        }, {passive: true});

        $(window).on('quickView', function () {
            document.querySelector('#modal-quick-view .modal__body').addEventListener('scroll', function () {
                checkVisible();
            }, {passive: true});
        })



    }, 100)

    $('.js-close-promo').on('click', function () {
        $(this).parents('.top-promo').slideUp();
    });

    $('.js-mobile-search-toggle').on('click', function () {
        $('.header__mobile-search').slideDown();
    });

    $('.js-close-search').on('click', function () {
        $('.header__mobile-search').slideUp();
    });

    $(document).on('click', '.js-input-stars .rating-stars__star', function () {
        const parent = $(this).parent('.js-input-stars');
        parent.attr('data-rating', $(this).index() + 1);
        renderStars(parent)
        $(this).trigger('rate-change');
    });

    $(document).on('click', '.js-close', function () {
        const parent = $(this).parent();
        parent.removeClass('opened');

        if (screen.width < 768) {
            if (parent.hasClass('color-size-picker')) {
                $(this).parents('.product-slider-redesign').removeClass('arrows-hidden');
            }
        }
    });



    const shopRatingSlider = new Swiper('.js-shop-rating-slider', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,

        navigation: {
            nextEl: '.shop-rating__arrow--next',
            prevEl: '.shop-rating__arrow--prev',
        },
    });



    function swipeScroll(element, item) {
        if (item !== null) {
            item.style.cursor = 'grab';
            let mouseMove = false;

            let pos = {top: 0, left: 0, x: 0, y: 0};

            const mouseDownHandler = function (e) {
                item.style.cursor = 'grabbing';
                item.style.userSelect = 'none';

                pos = {
                    left: item.scrollLeft,
                    top: item.scrollTop,
                    x: e.clientX,
                    y: e.clientY,
                };

                document.addEventListener('mousemove', mouseMoveHandler);
                document.addEventListener('mouseup', mouseUpHandler);
            };

            const mouseMoveHandler = function (e) {
                const dx = e.clientX - pos.x;
                const dy = e.clientY - pos.y;

                item.scrollTop = pos.top - dy;
                item.scrollLeft = pos.left - dx;
                mouseMove = true;
            };

            const mouseUpHandler = function (e) {
                item.style.cursor = 'grab';
                item.style.removeProperty('user-select');

                document.removeEventListener('mousemove', mouseMoveHandler);
                document.removeEventListener('mouseup', mouseUpHandler);
            };


            item.querySelectorAll(element + '> *').forEach(function (elem) {
                elem.addEventListener('click', function (e) {
                    if (mouseMove) {
                        e.preventDefault();
                    }
                    mouseMove = false;
                })

            });

            $(document).on("dragstart", element, function () {
                return false;
            });

            item.addEventListener('mousedown', mouseDownHandler);
        }
    }

    if (screen.width > 1199) {
        $('.js-swipe-scroll').each(function () {
            swipeScroll(`.${$(this).attr("class").split(/\s+/)[0]}`, $(this)[0]);
        })
        $('.js-swipe-scroll > *').attr('draggable', 'false');
        $('.js-swipe-scroll img').attr('draggable', 'false');
    }

    // Maps
    (function () {
        var mapContainer = document.querySelector('.our-works__map');

        if (!mapContainer) {
            return;
        }

        var spinner = mapContainer.querySelector('.loader');

        let mapsToLoad = [{
            id: 'works-map',
            isMultiPoint: true
        }]

        function init() {
            // Создание карт.
            function prepareMap(mapId, multiPoints = false) {

                let mapJsonPath = $('#' + mapId).attr('data-json')
                let myGeoObjects = [];
                let geoObjectsCentersSum = [0, 0];
                let mapCenterCoords = [0, 0];

                $.getJSON(mapJsonPath, function (data) {
                    data.map(function (geoObject) {
                        geoObjectsCentersSum[0] += geoObject.coords[0];
                        geoObjectsCentersSum[1] += geoObject.coords[1];

                        myGeoObjects
                            .push(new ymaps.Placemark(geoObject.coords, {
                                balloonContent: `<div class="our-works__bubble" data-id="${geoObject.id}">
                                                <div class="our-works__name">${geoObject.name}</div>
                                                <div class="our-works__date">${geoObject.date}</div>
                                                <a class="our-works__map-link" href="${geoObject.link}">Подробнее</a>
                                            </div>`
                            }, {
                                iconLayout: 'default#image',
                                iconImageHref: '/theme2/img/svg/marker.svg',
                            }))
                    })

                    //Считаем центр карты
                    if (multiPoints) {
                        mapCenterCoords[0] = +(geoObjectsCentersSum[0] / data.length).toFixed(4);
                        mapCenterCoords[1] = +(geoObjectsCentersSum[1] / data.length).toFixed(4);
                    } else {
                        mapCenterCoords = geoObjectsCentersSum;
                    }

                    function modalClose(modal) {
                        document.querySelector('body').classList.remove('scroll-hidden');
                        modal.remove()
                    }

                    function drawModal(data) {
                        var modal = document.querySelector('#works-map-template').content.querySelector('.works-modal').cloneNode(true);
                        var container = document.querySelector('.our-works__map');
                        var fragment = document.createDocumentFragment();

                        if (!modal) {
                            return;
                        }

                        var closeModalBtn = modal.querySelector('.works-modal__close');
                        var containerMedia = modal.querySelector('.our-project__img');
                        var mediaItem = containerMedia.querySelector('a');
                        var mediaItemPreview = mediaItem.querySelector('img');
                        var imageIcon = mediaItem.querySelector('.icon-photo-camera');
                        var videoIcon = mediaItem.querySelector('.icon-play-btn');
                        var count = mediaItem.querySelector('.our-project__img-num');

                        data.desc ? modal.querySelector('.our-project__desc').innerHTML = data.desc : '';
                        data.name ? modal.querySelector('.our-project__title').textContent = data.name : '';
                        data.date ? modal.querySelector('.our-project__date').textContent = data.date : '';
                        containerMedia.setAttribute('data-count', data.count);
                        if (data.images[0]) {
                            mediaItem.href = data.images[0].link;
                            mediaItem.setAttribute('data-fancybox', 'works-map-' + data.id);
                            mediaItemPreview.alt = data.name;
                            mediaItemPreview.src = data.images[0].thumb;
                            count.textContent = data.count;

                            if (data.images[0].isVideo === true) {
                                imageIcon.remove();
                            } else {
                                videoIcon.remove();
                                mediaItem.removeAttribute('data-video-project');
                            }

                            for (var i = 1; i < data.images.length; i++) {
                                var item = mediaItem.cloneNode(true);
                                var preview = item.querySelector('img');

                                item.querySelector('.our-project__cover').remove();
                                item.href = data.images[i].link;
                                preview.src = data.images[i].thumb;
                                preview.style.display = 'none';
                                if (data.images[i].isVideo !== true) {
                                    item.removeAttribute('data-video-project');
                                }

                                containerMedia.appendChild(item);
                            }
                        }

                        document.addEventListener('click', function (evt) {

                            if (evt.target.closest('.fancybox-stage') && !evt.target.closest('.fancybox-content')) {
                                modalClose(modal);
                            }
                            if (evt.target.closest('.works-modal') && !evt.target.closest('.works-modal__content')) {
                                modalClose(modal);
                            }
                        });

                        document.addEventListener('keydown', function (evt) {
                            if (evt.keyCode === 27) {
                                modalClose(modal);
                            }
                        });

                        containerMedia.addEventListener('click', function () {
                            function onBoxClickBtn() {
                                var boxCloseBtn = document.querySelector('.fancybox-button--close');
                                boxCloseBtn.addEventListener('click', function () {
                                    modalClose(modal);
                                });
                            }

                            setTimeout(onBoxClickBtn, 50);
                        });

                        closeModalBtn.addEventListener('click', function () {
                            var el = document.querySelector('.works-modal');
                            if (el !== null) {
                                modalClose(el);
                            }
                        });

                        modal.classList.add('active');

                        fragment.appendChild(modal);
                        container.appendChild(fragment);
                    }

                    document.addEventListener('click', function (evt) {
                        if (evt.target.closest('.our-works__map-link')) {
                            var content = document.querySelector('.our-works__bubble');
                            var container = content.parentElement.parentElement.parentElement;
                            var closeBtn = container.previousElementSibling;
                            var contentId = content.getAttribute('data-id');
                            var dataPin = data.find(item => item.id == contentId);
                            document.querySelector('body').classList.add('scroll-hidden');
                            evt.preventDefault();
                            closeBtn.click();
                            drawModal(dataPin);
                        }
                    });

                    var myMap = new ymaps.Map(mapId, {
                        center: mapCenterCoords,
                        zoom: 4,
                        controls: ['zoomControl'],
                    });

                    //Если будет много точек на карте, делаем кластерезацию
                    if (multiPoints) {


                        var myClusterer = new ymaps.Clusterer({
                            clusterIcons: [
                                {
                                    href: '/theme2/img/svg/marker.svg',
                                    size: [40, 40],
                                    offset: [-20, -20]
                                },
                                {
                                    href: '/theme2/img/svg/marker.svg',
                                    size: [50, 50],
                                    offset: [-30, -30]
                                }],
                            clusterNumbers: [10],
                            clusterIconContentLayout: null
                        });
                        myClusterer.add(myGeoObjects);
                        myMap.geoObjects.add(myClusterer);
                    }

                    //Если будет одна точка на карте, просто добавляем её
                    else {
                        myMap.geoObjects.add(myGeoObjects[0]);
                    }

                    myMap.behaviors.disable('scrollZoom');
                });
            }

            mapsToLoad.forEach(item => {
                if ($('#' + item.id).length > 0) {
                    prepareMap(item.id, item.isMultiPoint)
                }
            })

            mapContainer.querySelector('.placeholder').style.display = "none";

            if (spinner) {
                spinner.classList.remove('is-active');
            }
        }

        function mapLoad() {
            mapContainer.removeEventListener('mouseenter', mapLoad);
            const spinner = mapContainer.querySelector('.loader');
            if (spinner) {
                spinner.classList.add('is-active');
            }
            loadScript("https://api-maps.yandex.ru/2.1/?apikey=04709a29-6f21-442a-9cb5-272b39900456&lang=ru_RU", function () {
                ymaps.ready(init);
            });
        }

        mapContainer.addEventListener('mouseenter', mapLoad);
    })();

    const disableReadMore = (elements, height) => {
        if (elements.length > 0) {
            elements.each(function () {
                const parent = $(this).parents('.js-read-more-wrapper');
                if ($(this).height() <= height) {
                    parent.css('max-height', 'auto');
                    parent.find('.js-read-more-toggle').hide();
                    parent.siblings('.js-read-more-toggle').hide();
                    parent.find('.read-more-bg').hide();
                }
            })

        }
    }

    disableReadMore($('.catalog-tags .js-read-more-container'), 60);
    disableReadMore($('.testimonial .js-read-more-container'), 240);

    let initialFoldedHeight;

    $(document).on('click', '.js-read-more-toggle2', function(){
        $(this).closest('.read-more-wrapper').find('.js-read-more-partial-toggle:first').click();
    }).on('click', '.js-read-more-toggle', function () {
        const parent = $(this).parents('.js-read-more-wrapper').length > 0 ?
            $(this).parents('.js-read-more-wrapper') :
            $(this).parents('.js-read-more-additional-wrapper').find('.js-read-more-wrapper');
        let initialHeight = parent.find('.js-read-more-container').height();

        if (!$(this).hasClass('opened')) {
            parent.addClass('opened');
            initialFoldedHeight = parent.height();

            if ($(window).outerWidth() >= 768) {
                parent.animate({
                    height: initialHeight + (screen.width < 991 ? 30 : 0)
                }, 300);
            } else {
                parent.removeAttr('style');
            }
            $(this).addClass('opened');
            if ($(this).hasClass('_wt-text')) {
                $(this).text('Свернуть');
            }
        } else {
            parent.removeClass('opened');

            if ($(window).outerWidth() >= 768) {
                parent.animate({
                    height: initialFoldedHeight + (screen.width < 991 ? 30 : 0)
                }, 300);
            } else {
                parent.removeAttr('style');
            }
            $(this).removeClass('opened');
            if ($(this).hasClass('_wt-text')) {
                $(this).text('Развернуть');
            }
        }
    }).on('click', '.js-read-more-partial-toggle', function(){
        const parent = $(this).parents('.js-read-more-wrapper').length > 0 ?
            $(this).parents('.js-read-more-wrapper') :
            $(this).parents('.js-read-more-additional-wrapper').find('.js-read-more-wrapper');

        if ($(window).outerWidth() >= 768) {
            if (!$(this).hasClass('opened')) {
                parent.addClass('opened');
                $(this).addClass('opened');
            } else {
                parent.removeClass('opened');
                $(this).removeClass('opened');
            }
        } else {
            if (!$(this).hasClass('opened')) {
                const $items = parent.find('.js-read-more-item.js-hide-mobile').slice(0, 4);

                if ($items.length) {
                    $items.removeClass('js-hide-mobile');

                    if (!parent.find('.js-read-more-item.js-hide-mobile').length){
                        parent.addClass('opened');
                        $(this).addClass('opened');
                    }
                } else {
                    parent.addClass('opened');
                    $(this).addClass('opened');
                }
            } else {
                parent.removeClass('opened');
                $(this).removeClass('opened');
                parent.find('.js-read-more-item').slice(4).addClass('js-hide-mobile');
            }
        }
    });

    $('.js-subcategory-toggle').on('click', function () {
        const category = $(this).parent('.category-sidebar__category');
        const subcategories = category.siblings('.category-sidebar__subcategories');
        if (category.hasClass('opened')) {
            category.removeClass('opened');
            subcategories.slideUp(function () {
                subcategories.removeClass('opened');
            });
        } else {
            category.addClass('opened');
            subcategories.slideDown();
            subcategories.addClass('opened');
        }
    });

    $('.product-filters__item').on('click', '.product-filters__control', function (e) {
        if ($('.product-filters__clean').has(e.target).length) {
            clearFilter($(this).parent())
        } else {
            if (!$(this).parent().hasClass('is-active')) {
                $(this).parent().addClass('is-active');
                if ($(window).width() > 768) {
                    $(this).parent().siblings('.is-active').find('.product-filters__list').fadeOut();
                    $(this).parent().siblings('.is-active').removeClass('is-active');
                }
                $(this).parent().find('.product-filters__list').fadeIn();
            } else {
                $(this).parent().removeClass('is-active');
                $(this).parent().find('.product-filters__list').fadeOut();
            }
        }
    });

    $('.product-filters').on('click', '.product-filters__clear-all', function () {
        $('.product-filters__item.is-choosen').each(function () {
            clearFilter($(this));
        });
        if ($(window).width() > 768) {
            $(this).remove()
        }
    });

    $('.product-filters__mob-submit').on('click', function () {
        $('.product-filters').removeClass('is-active');
        document.body.style.overflow = 'visible';
        var container = $(".product-filters__item.is-active");
        submitFilter(container);
    });

    function submitFilter(item) {
        const choosenOptions = item.find('input[type="checkbox"]:checked').length;
        if (!$('.product-filters > .product-filters__clear-all').length && choosenOptions && $(window).width() > 768) {
            $('.product-filters').append("<button type='button' class='product-filters__clear-all'>Сбросить</button>")
        }
        if (choosenOptions) {
            item.addClass('is-choosen');
            if (!item.find('.product-filters__choosen-num').length && !item.find('.product-filters__clean').length) {
                item.find('.product-filters__control')
                    .append('<span class="product-filters__choosen-num">(' + choosenOptions + ')</span>')
                    .append('<span class="product-filters__clean"><svg width="8" version="1.1" xmlns="http://www.w3.org/2000/svg" height="8" viewBox="0 0 64 64" >\n' +
                        '<path fill="#fff" d="M28.941,31.786L0.613,60.114c-0.787,0.787-0.787,2.062,0,2.849c0.393,0.394,0.909,0.59,1.424,0.59   c0.516,0,1.031-0.196,1.424-0.59l28.541-28.541l28.541,28.541c0.394,0.394,0.909,0.59,1.424,0.59c0.515,0,1.031-0.196,1.424-0.59   c0.787-0.787,0.787-2.062,0-2.849L35.064,31.786L63.41,3.438c0.787-0.787,0.787-2.062,0-2.849c-0.787-0.786-2.062-0.786-2.848,0   L32.003,29.15L3.441,0.59c-0.787-0.786-2.061-0.786-2.848,0c-0.787,0.787-0.787,2.062,0,2.849L28.941,31.786z"/>\n' +
                        '</svg></span>');
            } else {
                item.find('.product-filters__choosen-num').html('(' + choosenOptions + ')');
            }
        } else {
            item.find('.product-filters__control').html(item.find('.product-filters__name').get(0));
            item.removeClass('is-choosen');
            if (!$('.product-filters').find('.is-choosen').length && $(window).width() > 768) {
                $('.product-filters > .product-filters__clear-all').remove();
            }
        }
    }
    window.syncProductFilterItem = submitFilter;

    // Чистим отдельный фильтр
    function clearFilter(item) {
        item.find('.product-filters__control').html(item.find('.product-filters__name').get(0));
        item.find('input[type=checkbox]').prop('checked', false);
        item.removeClass('is-choosen');
    }

    // кнопка применить в десктопной версии
    $('.product-filters__desktop-submit').on('click', function () {
        var container = $(this).closest(".product-filters__item");
        submitFilter(container);
        container.removeClass('is-active');
        container.find('.product-filters__list').fadeOut();
    });

    if ($(window).width() < 767) {
        $('.mobile-filters.mobile-filters--sort').append($('.js-sort'));
        $('.mobile-filters__categories').append($('.category-tags__list'));
        $('.mobile-filters__tags').append($('.js-tags-filter'));
        $(document).on('click', '.js-categories-toggle', function (e) {
            e.preventDefault();
            $(this).parent().find('.category-tags__list').slideToggle();
            $(this).parents('.mobile-filters__categories').toggleClass('is-active');
        });

        $(document).on('click', '.js-tabs-toggle', function (e) {
            e.preventDefault();
            var href = $(this).attr("href"),
                offsetTop = href === "#" ? 0 : $(href).offset().top;
            $('html, body').stop().animate({
                scrollTop: offsetTop
            }, 1000);
        });
        $(document).on('click', '.js-tags-toggle', function (e) {
            e.preventDefault();
            document.body.style.overflow = 'hidden';
            $('.product-filters').addClass('is-active');
            if (!$('.js-close-product-filters').length) {
                $('.product-filters').prepend('<button class="js-close-product-filters close-product-filters" type="button"><svg class="icon icon-cross"><use xlink:href="/theme2/img/svg/sprite.svg#cross"></use></svg></button>')

            }
        });

        $(document).on('click', '.js-close-product-filters', function (e) {
            document.body.style.overflow = 'visible';
            $('.product-filters').removeClass('is-active');
        });
    }

    $(document).on('click', '.js-answer-toggle', function () {
        $(this).parents('.testimonial').find('.testimonial__answer').slideToggle();
        $(this).toggleClass('opened');

        $(this).text($(this).hasClass('opened') ? 'Скрыть ответ' : 'Смотреть ответ');
    });

    const phones = document.querySelectorAll("input[type='tel']");

    $('.js-scroll-to').on('click', function (e) {
        e.preventDefault();
        const hash = $(this).attr('href').split('#')[1];
        const elementToScroll = $('#' + hash);

        let headerPadding = 147;
        if (screen.width < 991 && screen.width > 600) {
            headerPadding = 124;
        } else if (screen.width < 600) {
            headerPadding = 105;
        }
        console.log(headerPadding);

        if (elementToScroll.hasClass('accordion-section')) {
            elementToScroll.find('.js-accordion-toggle').addClass('active');
            elementToScroll.find('.js-accordion-content').addClass('opened');
        }

        $([document.documentElement, document.body]).scrollTop( elementToScroll.offset().top - headerPadding)

    });

    if(location.hash === '#product-video-presentation') {
        $('.js-product-card-main__video-link').click();
    }

    $(document).on('click', '.js-open-popup', function () {
        $('.js-open-popup').removeClass('opened');
        let popup = $(this).parent().find('.js-popup');
        popup.toggleClass('opened');
        renderClickableBG(false, popup, 'popup-bg', $('body'), false);
    });

    $(document).on('click', '.js-custom-select .custom-select-option', function () {
        const optionValue = $(this).attr('data-value');
        const optionsText = $(this).text();
        const customSelect = $(this).parents('.js-custom-select');
        customSelect.find('.custom-select__value').text(optionsText);

        customSelect.find('.custom-select-option').removeClass('_checked');
        $(this).addClass('_checked');

        setTimeout(function () {
            $('.clickable-bg').remove();
        }, 50);
        customSelect.find('option').each(function () {
            if ($(this).attr('value') === optionValue) {
                customSelect.find('select').val($(this).attr('value')).change();
            }
        })
    });

    // Accordion
    $(document).on('click', '.js-accordion-toggle', function () {
        $(this).toggleClass('active');
        $(this).next('.js-accordion-content').slideToggle(500, function () {
            $(this).toggleClass('opened');
        });
    }).on('click', '.js-accordion-close', function(){
        $(this).parent().parent().find('.js-accordion-toggle').click();
    });

    const options = {
        data: ["Москва", "Пятигорск", "Ростов", "Краснодар", "Якутск"],
    };

    $("#tes3").easyAutocomplete(options);

    $(document).on('change', '.js-file-upload', function () {
        $(this).siblings('.file-upload__upload-text').text('Файлы загружены')
    });

    $('.js-scroll-top-arrow').on('click', function () {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });

    $(window).on('scroll', function () {
        if (window.scrollY > screen.height) {
            $('.js-scroll-top-arrow').addClass('show')
        }
        else {
            $('.js-scroll-top-arrow').removeClass('show')
        }
    })

    var sportsmenSlider = $('.sportsmen__slider');
    sportsmenSlider.slick({
        variableWidth: true,
        arrows: false,
        dots: false

    });

    $(document).on('click', '.js-prev', function () {
        sportsmenSlider.slick('slickPrev');
    });

    $(document).on('click', '.js-next', function () {
        sportsmenSlider.slick('slickNext');
    });

    const ARROW_RIGHT_SVG = '<svg class="icon icon-arrow-right "><use xlink:href="/img/svgSprite/symbol/sprite.svg#prev"></use></svg>';

    $('.js-slider').slick({
        prevArrow: '<button type="button" class="slider-arrow-prev">' + ARROW_RIGHT_SVG + '</button>',
        nextArrow: '<button type="button" class="slider-arrow-next">' + ARROW_RIGHT_SVG + '</button>',
    });

    $('.js-toggle-link').each(function() {
        var beforeText = $(this).text();
        var afterText = 'Скрыть';
        $(this).on('click', function() {
            $(this).siblings('.js-toggle-content').fadeToggle();
            $(this).siblings('.js-toggle-content').toggleClass('active');
            $(this).toggleClass('active');

            $(this).hasClass('active') ? $(this).text(afterText) : $(this).text(beforeText);
        });
    });

    $('#checkout-form button[type="submit"]').on('click', function() {
        var form = $(this).closest('form');
        var inputs = form.find('input.js-total-check-validation');
        inputs.removeClass('invalid');

        inputs.each(function() {
            if ($(this).val() === '') {
                $(this).addClass('invalid');
                $('html, body').animate({
                    scrollTop: $(this).offset().top - $(window).height()/2
                }, 1000);
                return false;
            }
        });
    });
})


$(document).ready(function() {
    var myHash = location.hash;
    // location.hash = '';
    if(myHash[1] != undefined){
        $('html, body').animate({scrollTop: $(myHash).offset().top - 200}, 400);
    };

    $('a.js-anchor-link[href*="#"]').click(function (e) {
        var url = $(this).attr('href').replace('/', '');
        var target = $(url.substring(url.search('#')));
        if (target.length) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: target.offset().top - 200
            }, 400);
            return true;
        }
    });
});


$(document).ready(function() {
    $('[data-fancybox="product-slider-1"]').fancybox({
        loop: true,
        autoFocus: false
    });

    $(document).on('click', 'fancybox-slide', function(e) {
        if (!$('.fancybox-content').is(e.target) && $('.fancybox-content').has(e.target).length) {
            e.preventDefault();
            $.fn.fancybox.close();
            console.log('test');
        }

    });

    const productSliderRedesign = new Swiper('.js-athletes-slider-container', {
        loop: true,
        slidesPerView: 2.2,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        watchOverflow: true,
        autoplay: {
            delay: 9000,
            speed: 2000,
        },
        lazy: {
            loadPrevNext: true,
        },
        navigation: {
            nextEl: '.slider-redesign-arrow--next',
            prevEl: '.slider-redesign-arrow--prev',
        },
        breakpoints: {
            1200: {
                slidesPerView: 5,
                watchOverflow: true,

            },
            992: {
                slidesPerView: 4,
                watchOverflow: true,

            },
            600: {
                slidesPerView: 3.2,
                watchOverflow: true,
            }
        }
    });
});


